import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from 'remarketing-ui-components-lib';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-higher-existing-offer',
    templateUrl: './higher-existing-offer.component.html',
    styleUrls: ['./higher-existing-offer.component.scss'],
    imports: [TranslocoDirective, CommonModule]
})
export class HigherExistingOfferComponent {
  @Input() offerAmount: number;
  @Input() highestOfferAmount: number;
  @ViewChild(ModalComponent) modal: ModalComponent;
  @Output() continueOffer = new EventEmitter();
  @Output() cancelOffer = new EventEmitter();
  @Output() backOffer = new EventEmitter();
}
